export const EvidencijeResourcesDE: EvidencijeResourcesBSInterface = {
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
  odabirPoljaEvidencije: {
    title: "Evidenzfelder auswählen",
    buttonForward: "Hinzufügen",
    buttonBack: "Zurück",
    dropdownPlaceholder: "Evidenzfeld auswählen",
    successModal: {
      title: "Dateneingabe",
      body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
      buttonOk: "OK",
    },
    poljaEvidencije: {
      CIPP_V1: "Reinigung und Waschen von Räumen v1",
      CIPO_V1: "Reinigung und Waschen von Geräten v1",
      Dezinfekcija_V1: "Desinfektion v1",
      Dezinsekcija_V1: "Schädlingsbekämpfung v1",
      Dezinsekcija_V1_Kontrola: "Schädlingsbekämpfung Kontrolle v1",
      Dezinsekcija_V1_Korekcija: "Schädlingsbekämpfung Korrektur v1",
      Deratizacija_V1: "Nagetierkontrolle v1",
      Deratizacija_V1_Kontrola: "Nagetierkontrolle Kontrolle v1",
      Deratizacija_V1_Korekcija: "Nagetierkontrolle Korrektur v1",
      DezSr_V1: "Desinfektionsprodukte v1",
      Dobavljac_V1: "Lieferanten v1",
      Dostava_V1: "Lieferung / Wareneingang v1",
      EduZap_V1: "Mitarbeiterausbildung v1",
      Mol_V1: "Malerarbeiten v1",
      Oprema_V1: "Ausrüstung v1",
      Otpad_V1: "Abfall v1",
      PrijemRobe_V1: "Wareneingang v1",
      San_V1: "Sanitäre Inspektion v1",
      Temperatura_V1: "Temperaturlisten v1",
      TemperaturaOgranicenaEvd_V1: "Temperaturlisten - begrenzt v1",
      TemperaturaOgranicenaKKTEvd_V1: "Temperaturlisten - begrenzt - KKT - v1",
      TemperaturaKKTProizvodiEvd_V1: "Temperaturlisten - Produkte - KKT v1",
      FeedbackEvd_V1: "Feedback-Evidenz v1",
    },
  },
  evidencije: {
    notAllowed:
      "Sie haben nicht genügend Rechte, um diese Evidenz auszufüllen.",
    tackePrimjene: (count: number) => (
      <>Anwendungspunkte: Ausgewählt: {count}</>
    ),
    ucestalost: (type: string, count: number) => (
      <>
        Häufigkeit: Ausgewählt {type} ({count})
      </>
    ),
    odgovorneOsobe: (count: number) => (
      <>Verantwortliche Personen: Ausgewählte Kategorie ({count})</>
    ),
    poljaEvidencije: (polja: string) => {
      return <>{`Evidenzfelder: ${polja}`}</>;
    },
    nextButton: "Evidenz ausfüllen",
    backButton: "Zurück",
    saveButton: "Unterschreiben",
    deleteButton: "Evidenz löschen",
    deleteModal: {
      title: "Löschbestätigung",
      message:
        "Sind Sie sicher, dass Sie diese Evidenz löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
      confirmButton: "Ja, löschen",
      cancelButton: "Abbrechen",
      successTitle: "Erfolgreich gelöscht",
      successMessage: "Evidenz wurde erfolgreich gelöscht.",
      successButton: "Schließen",
    },
    deleteSuccess: "Evidenz erfolgreich gelöscht.",
    deleteError: "Fehler beim Löschen der Evidenz.",
    deselectAll: "Alle abwählen",
    noActiveRecords: {
      title: "Keine aktive Evidenz",
      message:
        "Für den gescannten Anwendungspunkt gibt es keine aktiven Evidenzdatensätze, die ausgefüllt werden müssen.",
      suggestion:
        "Die Evidenz wurde bereits für heute ausgefüllt. Bitte überprüfen Sie den Datumsbereich oder kontaktieren Sie den Administrator.",
    },
  },
};

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface PoljaEvidencije {
  CIPP_V1: string;
  CIPO_V1: string;
  Dezinfekcija_V1: string;
  Dezinsekcija_V1: string;
  Dezinsekcija_V1_Kontrola: string;
  Dezinsekcija_V1_Korekcija: string;
  Deratizacija_V1: string;
  Deratizacija_V1_Kontrola: string;
  Deratizacija_V1_Korekcija: string;
  DezSr_V1: string;
  Dobavljac_V1: string;
  Dostava_V1: string;
  EduZap_V1: string;
  Mol_V1: string;
  Oprema_V1: string;
  Otpad_V1: string;
  PrijemRobe_V1: string;
  San_V1: string;
  Temperatura_V1: string;
  TemperaturaOgranicenaEvd_V1: string;
  TemperaturaOgranicenaKKTEvd_V1: string;
  TemperaturaKKTProizvodiEvd_V1: string;
  FeedbackEvd_V1: string;
}

interface OdabirPoljaEvidencije {
  title: string;
  buttonForward: string;
  buttonBack: string;
  dropdownPlaceholder: string;
  successModal: SuccessModal;
  poljaEvidencije: PoljaEvidencije;
}

interface DeleteModal {
  title: string;
  message: string;
  confirmButton: string;
  cancelButton: string;
  successTitle?: string;
  successMessage?: string;
  successButton?: string;
}

interface NoActiveRecords {
  title: string;
  message: string;
  suggestion: string;
}

interface Evidencije {
  notAllowed: string;
  tackePrimjene: (count: number) => JSX.Element;
  ucestalost: (type: string, count: number) => JSX.Element;
  odgovorneOsobe: (count: number) => JSX.Element;
  poljaEvidencije: (polja: string) => JSX.Element;
  nextButton: string;
  backButton: string;
  saveButton: string;
  deleteButton: string;
  deleteModal: DeleteModal;
  deleteSuccess: string;
  deleteError: string;
  deselectAll: string;
  noActiveRecords: NoActiveRecords;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface EvidencijeResourcesBSInterface {
  odabirPoljaEvidencije: OdabirPoljaEvidencije;
  evidencije: Evidencije;
  errors: IErrors;
}
